/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EstimateWorkflowState } from './EstimateWorkflowState';
import {
    EstimateWorkflowStateFromJSON,
    EstimateWorkflowStateFromJSONTyped,
    EstimateWorkflowStateToJSON,
    EstimateWorkflowStateToJSONTyped,
} from './EstimateWorkflowState';

/**
 * 
 * @export
 * @interface GetEstimateWorkflowsByClaimId200Response
 */
export interface GetEstimateWorkflowsByClaimId200Response {
    /**
     * 
     * @type {Array<EstimateWorkflowState>}
     * @memberof GetEstimateWorkflowsByClaimId200Response
     */
    items: Array<EstimateWorkflowState>;
}

/**
 * Check if a given object implements the GetEstimateWorkflowsByClaimId200Response interface.
 */
export function instanceOfGetEstimateWorkflowsByClaimId200Response(value: object): value is GetEstimateWorkflowsByClaimId200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetEstimateWorkflowsByClaimId200ResponseFromJSON(json: any): GetEstimateWorkflowsByClaimId200Response {
    return GetEstimateWorkflowsByClaimId200ResponseFromJSONTyped(json, false);
}

export function GetEstimateWorkflowsByClaimId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEstimateWorkflowsByClaimId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(EstimateWorkflowStateFromJSON)),
    };
}

export function GetEstimateWorkflowsByClaimId200ResponseToJSON(json: any): GetEstimateWorkflowsByClaimId200Response {
    return GetEstimateWorkflowsByClaimId200ResponseToJSONTyped(json, false);
}

export function GetEstimateWorkflowsByClaimId200ResponseToJSONTyped(value?: GetEstimateWorkflowsByClaimId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(EstimateWorkflowStateToJSON)),
    };
}

